import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { Button } from "antd";
import _ from "i18n";

import { setCategoryExtraSlideList } from "Actions";
import { saveCategoryExtraSlide, deleteCategoryExtraSlide } from "Thunks";

import { onSuccess, onError } from "Utils";
import { DIALOG_TYPES } from "../../config";
import TTPDialog from "../Common/TTPDialog";
import { SettingIconTwo, SvgIcon, ICONS, Garbage } from "../Common/Icons";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";

import styles from "./CategorySettingContent.local.scss";

class CategorySettingContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idCategory: null,
      category: {
        id: null,
        label: ""
      },
      disabledSave: true,
      deleteCategoryIsVisible: false
    };
  }

  handleDisplayDeleteCategory = id => {
    this.setState({
      idCategory: id,
      deleteCategoryIsVisible: true
    });
  };

  handleDeleteCategory = () => {
    const { categorySettings, dispatch } = this.props;
    let updatedCategoryList = categorySettings.categoryList;
    let { idCategory } = this.state;
    this.setState({ loading: true });

    dispatch(deleteCategoryExtraSlide(idCategory)).then(
      res => {
        this.setState({ loading: false });
        onSuccess(res, {
          title: _("removeSuccess"),
          body: _("categoryDeleted")
        });
        dispatch(
          setCategoryExtraSlideList(
            updatedCategoryList.filter(({ id }) => id !== idCategory)
          )
        );
        this.cancelDeleteCategory();
      },
      err => {
        this.cancelDeleteCategory();
        this.setState({ loading: false });
        onError(err.response.data.errors[0].message);
      }
    );
  };

  cancelDeleteCategory = () => {
    this.setState({
      idCategory: null,
      deleteCategoryIsVisible: false
    });
  };

  handlePrepareUpdateCategory = categoryToUpdate => {
    this.setState({ category: categoryToUpdate });
  };

  handleChangeCategoryLabel = event => {
    this.setState({
      category: { ...this.state.category, label: event.target.value },
      disabledSave: false
    });
  };

  cancelUpdateCategory = () => {
    this.setState({
      category: {
        id: null,
        label: ""
      },
      disabledSave: true
    });
  };

  handleSaveCategory = () => {
    const { category } = this.state;
    const { dispatch, categorySettings } = this.props;
    let updatedCategoryList = categorySettings.categoryList;

    dispatch(
      saveCategoryExtraSlide(category.label, category.id ? category.id : null)
    ).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: category.id ? _("categoryUpdated") : _("categoryCreated")
        });
        if (!category.id) {
          const categorySaved = {
            label: category.label,
            id: res.value.data.data.id
          };
          updatedCategoryList = [categorySaved, ...updatedCategoryList];
          dispatch(setCategoryExtraSlideList(updatedCategoryList));
        } else {
          updatedCategoryList.filter(({ id }) => id === category.id)[0].label =
            category.label;
          dispatch(setCategoryExtraSlideList(updatedCategoryList));
        }

        this.setState({
          disabledSave: true,
          category: {
            id: null,
            label: ""
          }
        });
      },
      err => {
        onError(
          err.response.data.errors
            ? err.response.data.errors[0].message
            : _("error")
        );
      }
    );
  };

  render() {
    const { categorySettings } = this.props;
    const { category, disabledSave } = this.state;
    return (
      <div className="tamtam-modal upload-modal upload-modal__body">
        <ModalCloseButton onClose={this.props.onCancel} />
        <div className="upload-modal__content">
          <div className="upload-modal__header small-12">
            <div className="upload-modal__header-icon">
              <SettingIconTwo fill="#2495E1" size="20" />
            </div>
            <div className="upload-modal__header-title">
              {_("titleModalCategory")}
            </div>
          </div>
          <div className={styles.modal_content}>
            <div
              className={classnames(
                "columns medium-5 small-5",
                styles.form_frame
              )}
            >
              <h3>{_(category.id ? "updateCategory" : "createCategory")}</h3>
              <div
                className={classnames(
                  "columns medium-12 small-12",
                  styles.input_div
                )}
              >
                <span>{_("title")}</span>
                <input
                  type={"text"}
                  value={category.label}
                  onChange={event => this.handleChangeCategoryLabel(event)}
                />
              </div>
              <div>
                <button
                  type={"success"}
                  className={styles.save_button}
                  disabled={disabledSave || category.label === ""}
                  onClick={this.handleSaveCategory}
                >
                  <img src={"/img/icons/tail-spin.svg"} alt={""} />
                  {_("save")}
                </button>
                {category.id && (
                  <Button
                    type={"success"}
                    style={{
                      fontFamily: "Roboto",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: 14,
                      height: 37,
                      margin: "18px 3px 0px",
                      background: "transparent",
                      float: "left",
                      textTransform: "uppercase",
                      color: "#6D7F92"
                    }}
                    onClick={() => this.cancelUpdateCategory()}
                  >
                    {_("cancel")}
                  </Button>
                )}
              </div>
            </div>
            <div
              className={classnames(
                "columns medium-6 small-6",
                styles.list_frame
              )}
            >
              <h3>
                {_("categoryList")} ({categorySettings.categoryList.length})
              </h3>
              <div className={`${styles.list_items} ${styles.list_roles}`}>
                {categorySettings.fetching ? (
                  <div className={styles.ripple_loading}>
                    <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                  </div>
                ) : (
                  categorySettings.categoryList &&
                  categorySettings.categoryList.map(category => {
                    return (
                      <div key={category.id} className={styles.item}>
                        <span>{category.label}</span>
                        <div
                          className={styles.actions}
                          onClick={event => {
                            event.stopPropagation();
                          }}
                        >
                          <div>
                            <span
                              className={`${styles.action} ${
                                styles.action_edit
                              }`}
                              onClick={() =>
                                this.handlePrepareUpdateCategory(category)
                              }
                            >
                              <SvgIcon
                                icon={ICONS.PENCIL}
                                className={styles.edit}
                              />
                            </span>
                            <span
                              className={`${styles.action} ${
                                styles.action_delete
                              }`}
                              onClick={() =>
                                this.handleDisplayDeleteCategory(category.id)
                              }
                            >
                              <SvgIcon
                                icon={ICONS.Garbage}
                                className={styles.delete}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
        <TTPDialog
          showDialog={this.state.deleteCategoryIsVisible}
          loading={this.state.loading}
          closable={false}
          TTPDialog={{
            approvedAction: this.handleDeleteCategory,
            abortAction: this.cancelDeleteCategory,
            message: (
              <span
                dangerouslySetInnerHTML={{
                  __html: _("confirmationDeleteCategoryMessage")
                }}
              />
            ),
            icon: <Garbage />,
            proceedBtnLabel: "yes",
            abortBtnLabel: "no",
            type: DIALOG_TYPES.ALERT,
            title: _("confirmationDeleteCategoryTitle")
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  categorySettings: state.extraSlideList.categorySettings
});

export default connect(mapStateToProps)(CategorySettingContent);



// WEBPACK FOOTER //
// ./src/components/ExtraSlides/CategorySettingContent.js